import { s } from "../../../../utilities/common"

export const GenresIcon = () => (
  <svg
    width={s("40")}
    height={s("40")}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8828 1.65918H4.02978C2.72053 1.65918 1.65918 2.72053 1.65918 4.02978V15.8828C1.65918 17.192 2.72053 18.2534 4.02978 18.2534H15.8828C17.192 18.2534 18.2534 17.192 18.2534 15.8828V4.02978C18.2534 2.72053 17.192 1.65918 15.8828 1.65918Z"
      stroke="white"
    />
    <path
      d="M29.8694 14.9345C32.6188 14.9345 34.8476 12.7057 34.8476 9.95628C34.8476 7.20687 32.6188 4.97803 29.8694 4.97803C27.12 4.97803 24.8911 7.20687 24.8911 9.95628C24.8911 12.7057 27.12 14.9345 29.8694 14.9345Z"
      stroke="white"
    />
    <path
      d="M9.95652 24.8911L16.5942 34.8476H3.31885L9.95652 24.8911Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M35.7959 21.5723H23.9429C22.6336 21.5723 21.5723 22.6336 21.5723 23.9429V35.7959C21.5723 37.1051 22.6336 38.1665 23.9429 38.1665H35.7959C37.1051 38.1665 38.1665 37.1051 38.1665 35.7959V23.9429C38.1665 22.6336 37.1051 21.5723 35.7959 21.5723Z"
      stroke="white"
    />
  </svg>
)
